export default __webpack_public_path__ + "static/media/sistemab1.73a83f1f.jpg";